<template>
    <div class="square-image-box">
        <CmsLink
            v-if="data.link"
            :link="data.link"
        >
            <CmsImage
                :data="data.image"
                :is-eager="hasEagerImage"
                fit="cover"
            />
        </CmsLink>

        <CmsImage
            v-else
            :data="data.image"
            :is-eager="hasEagerImage"
            fit="cover"
        />
    </div>
</template>

<script lang="ts" setup>
import type { SquareImageBoxFragment } from '@/graphql/api'
import CmsLink from '@/components/cms/CmsLink.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

defineProps<{
    data: SquareImageBoxFragment
    hasEagerImage?: boolean
}>()
</script>

<style lang="scss" scoped>
.square-image-box {
    width: 100%;
    aspect-ratio: 1/1;
    background: $stone-2;
}
</style>
